import React from "react";
import Loaded from '../../../../../dev/terminal/components/loader';
import _ from 'lodash';
import { DrawMarketHeader } from '../../../../../dev/helpers/asianHelpers/index';
import AsianGameListCompetition from '../../../../../dev/terminal/components/asianGameListCompetition';
import { MarketContextProvider } from "../../../../../dev/terminal/components/gameListAsian/marketContext";

export default function gameListAsianTemplate() {
    let { data: datawithsports, loaded, sportAlias, selectorKey, marketsSelectorKey, gameType } = this.props, data = [];
    if (sportAlias === 'all' && datawithsports) {
        return (<div id='getScrollPosition' className={"all-games-list-wrapper scroll-always" + (loaded ? " loading " : "")} ref={(el) => this.scrollGamesListAsian = el} onClick={this.props.uiClose("openRegion")} onScroll={this.handleScrollListener} >
            <div className="asian-view-wrapper">
                {
                    datawithsports.map((sportType) => {
                        return (
                            <React.Fragment>
                                <MarketContextProvider sportAlias={sportType.temp} gameType={gameType}>
                                    <div className={`asian-top-row ${sportType.temp}`}>
                                        <div className="a-title">
                                            <div className="market-t-v" ><p className="a-market-name-t">{sportType.temp}</p></div>
                                            <DrawMarketHeader gameType={gameType} sportAlias={sportType.temp} />
                                            <div className="market-t-v" />
                                        </div>
                                    </div>
                                    {
                                        (() => {
                                            data = sportType.data;
                                            const outPutData = [];
                                            for (let i = 0, gameCount = 0; i < data.length; i++) {
                                                gameCount += data[i][data[i].key].length;
                                                if (gameCount > this.state.gameLoadCount) {
                                                    outPutData.push((
                                                        <AsianGameListCompetition key={data[i].regionAlias + data[i].key}
                                                            competition={{ ...data[i], [data[i].key]: data[i][data[i].key].slice(0, this.state.gameLoadCount) }}
                                                            selectorKey={selectorKey}
                                                            marketsSelectorKey={marketsSelectorKey}
                                                            gameType={gameType}
                                                            sportAlias={sportType.temp} />
                                                    ));
                                                    break;
                                                }
                                                outPutData.push((
                                                    <AsianGameListCompetition key={data[i].regionAlias + data[i].key}
                                                        competition={data[i]}
                                                        selectorKey={selectorKey}
                                                        marketsSelectorKey={marketsSelectorKey}
                                                        gameType={gameType}
                                                        sportAlias={sportType.temp} />
                                                ));
                                            }
                                            return outPutData;
                                        })()
                                    }
                                </MarketContextProvider>
                            </React.Fragment>
                        );
                    })
                }
            </div>
            <div className="scroll-b-view-w">
                <div className="single-s-b top-v" onClick={this.scroll(-200)} />
                <div className="single-s-b bot-v" onClick={this.scroll(200)} />
            </div>
        </div>);
    } else if (datawithsports) {
        const data = datawithsports;
        return <div id='getScrollPosition' className={"all-games-list-wrapper scroll-always" + (loaded ? " loading " : "")} ref={(el) => this.scrollGamesListAsian = el} onClick={this.props.uiClose("openRegion")} onScroll={this.handleScrollListener} >
            <div className="asian-view-wrapper">
                <MarketContextProvider sportAlias={sportAlias} gameType={gameType}>
                    <div className={`asian-top-row ${sportAlias}`}>
                        <div className="a-title">
                            <div className="market-t-v" />
                            <DrawMarketHeader gameType={gameType} sportAlias={sportAlias} />
                            <div className="market-t-v" />
                        </div>
                    </div>
                    {
                        (() => {
                            const outPutData = [];
                            for (let i = 0, gameCount = 0; i < data.length; i++) {
                                gameCount += data[i][data[i].key].length;
                                if (gameCount > this.state.gameLoadCount) {
                                    outPutData.push((
                                        <AsianGameListCompetition key={data[i].regionAlias + data[i].key}
                                            competition={{ ...data[i], [data[i].key]: data[i][data[i].key].slice(0, this.state.gameLoadCount) }}
                                            selectorKey={selectorKey}
                                            marketsSelectorKey={marketsSelectorKey}
                                            gameType={gameType}
                                            sportAlias={sportAlias} />
                                    ));
                                    break;
                                }
                                outPutData.push((
                                    <AsianGameListCompetition key={data[i].regionAlias + data[i].key}
                                        competition={data[i]}
                                        selectorKey={selectorKey}
                                        marketsSelectorKey={marketsSelectorKey}
                                        gameType={gameType}
                                        sportAlias={sportAlias} />
                                ));
                            }
                            return outPutData;
                        })()
                    }
                </MarketContextProvider>
            </div>
            <div className="scroll-b-view-w">
                <div className="single-s-b top-v" onClick={this.scroll(-200)} />
                <div className="single-s-b bot-v" onClick={this.scroll(200)} />
            </div>
        </div>;
    } else {
        return <Loaded />;
    }
}